import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from '@mui/x-data-grid';
import { alpha, CircularProgress, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import { ToolbarSearchInput } from '@components/DataGrid/ToolbarSearchInput';
import DataTableButton from '../../../components/buttons/dataTableTopButton';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    searchText: string;
    onSearchChange: (value: string) => void;
    onAddAgency: () => void;
    onExportUserList: () => void;
    isExportingUserList: boolean;
  }
}

interface AgenciesTableToolbarProps {
  searchText: string;
  onSearchChange: (newValue: string) => void;
  onAddAgency: () => void;
  onExportUserList: () => void;
  isExportingUserList: boolean;
};

const AgenciesTableToolbar = ({
  searchText,
  onSearchChange,
  onAddAgency,
  onExportUserList,
  isExportingUserList
}: AgenciesTableToolbarProps) => {
  const theme = useTheme();

  return (
    <GridToolbarContainer
      data-testid='custom-toolbar'
      sx={{ padding: 1, justifyContent: 'flex-start' }}
    >
      <ToolbarSearchInput
        value={searchText}
        onChange={(newValue) => onSearchChange(newValue as unknown as string)}
      />
      <GridToolbarColumnsButton />
      <DataTableButton
        background={alpha(theme.palette.background.paper, 0.7)}
        startIcon={<AddIcon />}
        buttonText="Add Agency"
        onClick={onAddAgency}
      />
      <DataTableButton
        background={alpha(theme.palette.background.paper, 0.7)}
        startIcon={isExportingUserList ? <CircularProgress size={16} /> : <DownloadIcon />}
        buttonText="Export User List"
        onClick={onExportUserList}
        disabled={isExportingUserList}
      />
    </GridToolbarContainer>
  );
};

export default AgenciesTableToolbar;
